import { IconTypes } from "./types";

export default function DuplicateIcon({
  width = "19",
  height = "19",
  fill = "#29129D",
}: Partial<IconTypes>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 0H4C2.9 0 2 0.9 2 2V12C2 13.1 2.9 14 4 14H14C15.1 14 16 13.1 16 12V2C16 0.9 15.1 0 14 0ZM14 12H4V2H14V12Z"
        fill={fill}
      />
      <path
        d="M18 4H8C6.9 4 6 4.9 6 6V16C6 17.1 6.9 18 8 18H18C19.1 18 20 17.1 20 16V6C20 4.9 19.1 4 18 4ZM18 16H8V6H18V16Z"
        fill={fill}
        fillOpacity="0.8"
      />
    </svg>
  );
}
